module.exports = __webpack_public_path__ + "media/images/emblems/Appenzell-Wappen-2f2743f91e9fa35d68f7be435ca74544.png";